import { useEffect, useState } from 'react';

export default function Intro({ onComplete }) {
    const [fontReady, setFontReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        // Keep the black screen, but never paint the title in a fallback font.
        // Skip the intro if the font fails so the site remains accessible.
        const timeout = window.setTimeout(onComplete, 4000);
        if (!document.fonts?.load || document.documentElement.classList.contains('font-fallback')) {
            onComplete();
        } else {
            document.fonts.load('300 36px "Neue Montreal"', 'Jonathan Edward Portfolio')
                .then((fonts) => {
                    if (cancelled) return;
                    window.clearTimeout(timeout);
                    if (fonts.length) setFontReady(true);
                    else onComplete();
                })
                .catch(() => {
                    if (!cancelled) onComplete();
                });
        }
        return () => {
            cancelled = true;
            window.clearTimeout(timeout);
        };
    }, [onComplete]);

    useEffect(() => {
        if (!fontReady) return undefined;
        // Also release the page if an animation-end event is missed.
        const timeout = window.setTimeout(onComplete, 3500);
        return () => window.clearTimeout(timeout);
    }, [fontReady, onComplete]);

    return (
        <div
            className={`sig-intro${fontReady ? ' sig-intro-ready' : ''}`}
            aria-hidden="true"
            onAnimationEnd={(event) => {
                if (event.target === event.currentTarget) onComplete();
            }}
        >
            <div className="sig-intro-title">
                <span className="sig-intro-name">Jonathan Edward</span>{' '}
                <span className="sig-intro-portfolio">Portfolio</span>
            </div>
        </div>
    );
}
